import { render, staticRenderFns } from "./kInput.vue?vue&type=template&id=3a05f026&scoped=true&"
import script from "./kInput.vue?vue&type=script&lang=js&"
export * from "./kInput.vue?vue&type=script&lang=js&"
import style0 from "./kInput.vue?vue&type=style&index=0&id=3a05f026&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a05f026",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
